import { render, staticRenderFns } from "./properIndusry.vue?vue&type=template&id=eb5d4d66"
import script from "./properIndusry.vue?vue&type=script&lang=js"
export * from "./properIndusry.vue?vue&type=script&lang=js"
import style0 from "./properIndusry.vue?vue&type=style&index=0&id=eb5d4d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports